// extracted by mini-css-extract-plugin
export default {"overlay":"TrainingRegisterModal_overlay__lZcaL modal-panel-enter","body":"TrainingRegisterModal_body__c1lAQ"};